import React from 'react'
import { InputProps } from 'react-admin'

export const EventDescription = ({ record }: InputProps) => {
  if (!record.eventData) return null
  const { description } = JSON.parse(record.eventData)
  return <span>{description}</span>
}
